import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: ['AVOD_DP_season_selector'] as const,
}
